const messages = {
  _default: "Недопустимое значение",
  email: "E-mail недействителен",
  numeric: "Значение должно быть числом",
  required: "Обязательно для заполнения",
  confirmed: "Значения не совпадают",
  minLength: ({ min }) => `Не менее ${min} символов`,
  maxLength: ({ max }) => `Не более ${max} символов`,
  size: "Вес файла превышен",
  ext: ({ ext }) => `Поле должно быть действительным файлом. (${ext})`,
  dimension: "Превышены допустимые размеры изображения",
  alpha: "Допускаются только буквы алфавита",
  appAlpha: "Допускаются только буквы алфавита",
  appAlphaNum: "Допускаются только буквы алфавита и числа",
  sameAs: "Значение не совпадает",
  minValue: ({ min }) => `Минимальное значение: ${min}`
};

export function getValidationMessage(field) {
  if (!field.$dirty) return null;
  const keys = Object.keys(field.$params);
  let key;
  for (let i = 0; i < keys.length; i++) {
    key = keys[i];

    if (field[key] === false) {
      const message = messages[key];
      if (message) {
        if (typeof message === "function") return message(field.$params[key]);
        return message;
      } else {
        return messages._default;
      }
    }
  }
  return null;
}
